import * as React from 'react';
import { useSelector } from 'react-redux';

import { StickyScrollBtn } from '../../components/StickyScrollBtn';
import { selectIsStickyScrollBtnVisible } from '../../selectors/page';
import { useButtonText } from '../AddNewCard';
import { useButtonSticky } from './hook';

interface IStickyScrollBtnContainerParams {
  scrollToFilters(): void;
}

export function StickyScrollBtnContainer({ scrollToFilters }: IStickyScrollBtnContainerParams) {
  const stickyRef = React.useRef<HTMLElement>(null);

  const isStickyBtnVisible = useSelector(selectIsStickyScrollBtnVisible);

  const buttonText = useButtonText();
  const isBtnSticky = useButtonSticky(stickyRef.current);

  if (!isStickyBtnVisible) {
    return null;
  }

  return (
    <StickyScrollBtn
      stickyRef={stickyRef as React.Ref<HTMLDivElement>}
      isSticky={isBtnSticky}
      scrollToFilters={scrollToFilters}
      buttonText={buttonText}
    />
  );
}
